import { useCommunityWithdraws } from "../../store/useCommunityWithdraws";

export const CommunityDonationsTable = () => {
  /** Hooks */
  const { donations } = useCommunityWithdraws();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Donor
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Email
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Amount
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Date
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Lottery Status
            </th>
          </tr>
        </thead>
        <tbody>
          {donations?.length
            ? donations.map((donation) => (
                <tr
                  key={donation.donationId}
                  className="bg-white hover:bg-gray-100 transition ease-linear border-b"
                >
                  <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                    {donation.user.first_name} {donation.user.last_name}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {donation.user.email}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    €{(donation.amount / 100).toFixed(2)}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {formatDate(donation.createdAt)}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    <span
                      className={`px-2 py-1 rounded text-xs font-medium ${
                        donation.isPartOfLottery
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {donation.isPartOfLottery
                        ? "Lottery Entry"
                        : "Regular Donation"}
                    </span>
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};
